import { useRouter } from "vue-router";

export default async (to) => {
    const currentRouteName = to.name;

    if ( currentRouteName == "dashboard" ) return checkAndRedirectAfterLogin()
}



/**
 * Verifica e redireciona o usuário após o login, caso haja uma rota salva no sessionStorage.
 * Se houver um `tab` especificado, também tenta ativá-lo após o redirecionamento.
 *
 * @async
 * @function checkAndRedirectAfterLogin
*/
const checkAndRedirectAfterLogin = async () => {
    const router = useRouter();

    const redirectData = sessionStorage.getItem("redirectAfterLogin");

    
    if ( !redirectData ) return;


    const { path, tab } = JSON.parse(redirectData);

    sessionStorage.removeItem("redirectAfterLogin");


    if ( !path ) return;


    try {
        await router.push(`/${path}`);

        await new Promise(resolve => setTimeout(resolve, 500));

        // O Link veio com #tabName
        if ( tab ) {
            const elementTab = document.querySelector(`#tab-${tab}`);

            if (!elementTab) throw new Error(`Tab não encontrada: #tab-${tab}`);

            elementTab.click();
        }

    } catch (error) {
        console.error(`afterEach: Houve um erro ao redirecionar para a rota ${path}`, error)
    }
}